import React, { useState, useEffect } from "react";
import { Button, Col, Label } from "reactstrap";

import failure from "../../../src/waitlistDocVault/assets/images/failure.png";
import success from "../../../src/waitlistDocVault/assets/images/success.png";
import verification from "../../../src/waitlistDocVault/assets/images/Verification.png";

import { downloadPreviewData } from "../../waitlist/services/waitlist-service";
import { toast, ToastContainer } from "react-toastify";
import { setAnalyticsEvent } from "../../core/helpers/analytics";
import { OroLoaderInline } from "../../core";
import AddressPreview from "./AddressPreview";
// import { Mixpanel } from "../../waitlist/components/MixPanel";

export default function KycAdressPreview(props) {
  const { setReupload } = props;

  const [docs, setDocs] = useState(
    () => {
      return props.docs;
    }
  );
  const [errors, setErrors] = useState(props.errors);
  const [previewObj, setPreviewObj] = useState({});
  const [loader, setLoader] = useState(false);
  const [addressDetails, setAddressDetails] = useState({});
  const [isPreview, setIsPreview] = useState(false);
  const [addressFile, setAddressFile] = useState([]);

  const checkIfPdf = (filename) => {
    let tempFilenameArr = filename.split('.');
    return tempFilenameArr[tempFilenameArr.length - 1] === 'pdf';
  }

  useEffect(async () => {
    let docTypes = ['pan', 'poi', 'address', 'address_1']
    setLoader(true);
    for (let type of docTypes) {
      let doc = docs.find(e => e.type === type);
      if (doc) {
        let file = await downloadPreviewData(doc.data)
        .then((res, err) => {
          if (!res || res.err) {
            toast.error(
              err.msg || "Not able to fetch data. Please try again"
            );
            return;
          }
          return URL.createObjectURL(res);          
        })
        let imgTempObj =  previewObj;
        imgTempObj[type] = {
          data: file,
          filename: doc.data
        }
        setPreviewObj({...imgTempObj});
      }      
    }
  }, [docs]);

  useEffect(() => {
    if (props.userProfile && props.userProfile.addressDetails) {
      setAddressDetails(props.userProfile.addressDetails);
    }
  }, [props.userProfile])

  useEffect(() => {
    if (Object.keys(previewObj).length) {
      setLoader(false);
    }
  }, [previewObj]);

  useEffect(() => {
    if (addressFile && addressFile.length) {
      setIsPreview(true);
    }
  }, [addressFile]);

  const previewAddress = () => {
    // Get the docs from /getUserDocsWithPan
    // Filter address related docs
    // set the docs so that address modal can open/show
    // getUploadedDocsList(userProfile?.pan || pan).then((docsList) => {
    
    if (props.uploadedDocs.length) {
      let filename = props.uploadedDocs.filter(e => e.type === 'pan' ||
        e.type === 'poi' ||  e.type === 'address' || e.type === 'address_1');
      setAddressFile([...filename]);
    }
  }

  const getAddressStatus = () => {
    if (props.isKycDone) {
      return <>
        <p className="mb-0">
          Your KYC is verified successfully
        </p>
        <img src={success} alt="success-icon"/>
      </>
    } 
    if (errors && errors.length) {
      return <>
        <p className="mb-0">
          Your KYC verification is failed
        </p>
        <img src={failure} alt="failure-icon"/>
      </>
    } 
    if ((errors && !errors.length) || !errors) {
      return <>
        <p className="mb-0">
          Your KYC verification is under process
        </p>
        <img src={verification} alt="success-icon"/>
      </>
    }
  }

  const editAddress = () => {
    setAnalyticsEvent(window.location.pathname + window.location.hash,
      "Postlogin_orobonds_docvault_Address_Edit_Clicked"
    );
    // Mixpanel.track("cl_edit_kyc_address_docvault");
    setReupload(true)
  }

  const getUserDetails = () => {
    return props.userProfile &&
      props.userProfile.digioKyc &&
      props.userProfile.digioKyc.aadhar
      ? props.userProfile.digioKyc.aadhar
      : {
        name: '',
        id_number: ''
      };
  }

  const getConcatedErrRemarks = () => {    
    return errors.reduce(
      (errConcat, item) => errConcat + ', ' + item.remarks,
      ''
    );
  }

  return (
    <>
      <div className="adress-window">
        <div className="adress-status text-capitalize">
          {getAddressStatus()}
        </div>

        {errors && errors.length ? (
          <div className="banner mt-3 d-flex">
            <p>
              {getConcatedErrRemarks().substring(2)}
            </p>
            {/* <span class="mdi mdi-close-circle-outline"></span> */}
          </div>
        ) : null}

        <div className="adress-details border">
          <div className="address-ip-container">
          {getUserDetails().name && <>
            <div className="each-detail">              
              <Label className="font-size-tiny text-muted">Name</Label>
              <p className="text-capitalize font-weight-semi-bold">
                {getUserDetails().name || 'NA'}
              </p>
            </div>
            <div className="each-detail">
              <Label className="font-size-tiny text-muted">ID Number</Label>
              <p className="text-capitalize font-weight-semi-bold">
                {getUserDetails().id_number || 'NA'}
              </p>
            </div>
            </>}
            <div className="each-detail">
              <Label className="font-size-tiny text-muted">Address</Label>
              <p className="text-capitalize font-weight-semi-bold">
                {addressDetails.address || 'NA'}
              </p>
            </div>
            <div className="each-detail">
            <Label className="font-size-tiny text-muted">
              Locality or Post Office
            </Label>
            <p className="text-capitalize font-weight-semi-bold">
              {addressDetails.localityOrPostOffice || 'NA'}
            </p>
            </div>
            <div className="each-detail">
            <Label className="font-size-tiny text-muted">
              City
            </Label>
            <p className="text-capitalize font-weight-semi-bold">
              {addressDetails.districtOrCity || 'NA'}
            </p>
            </div>
            <div className="each-detail">
            <Label className="font-size-tiny text-muted">
              State
            </Label>
            <p className="text-capitalize font-weight-semi-bold">
              {addressDetails.state || 'NA'}
            </p>
            </div>
            <div className="each-detail">
            <Label className="font-size-tiny text-muted">
              Country
            </Label>
            <p className="text-capitalize font-weight-semi-bold">
              {addressDetails.country || 'NA'}
            </p>
            </div>
            <div className="each-detail">
            <Label className="font-size-tiny text-muted">
              Pin Code
            </Label>
            <p className="font-weight-semi-bold">
              {addressDetails.pincode || 'NA'}
            </p>
            </div>
          </div>
          <div className="btn-container mt-3">
            {!props.isKycDone && (
              <div className="submit" onClick={editAddress}>
                <Button color="secondary" outline>Edit</Button>
              </div>
            )}
            <Button
              className="nxt"
              onClick={props.moveNextTab}
              disabled={errors.length}
            >
              Next
            </Button>
            <Button
              className="nxt"
              onClick={previewAddress}
            >
              Preview Documents
            </Button>
          </div>
        </div>

        
      </div>
      {isPreview ? <AddressPreview
        isOpen={isPreview}
        toggle={() => setIsPreview(false)}
        address={addressFile}
      /> : null}
      <ToastContainer />
    </>
  );
}